var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{staticClass:"w-full",attrs:{"success":"","outline":"","small":""},on:{"click":_vm.manageReviews}},[_vm._v(" Manage Reviews ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }